import { createSlice } from '@reduxjs/toolkit';
import { getAgentNote, getListAgent } from './agentThunk';
import { IAgentNote } from '~/data/agent';

interface IAgentState {
  loading: boolean;
  agents: {};
  agentNote: IAgentNote;
}

const initialState: IAgentState = {
  loading: false,
  agents: {},
  agentNote: {},
};

const listAgentSlice = createSlice({
  name: 'agent/listAgent',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getListAgent.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getListAgent.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = action.payload.data;
      })
      .addCase(getListAgent.rejected, (state, action) => {
        state.loading = false;
      })

      //Get Agent Note
      .addCase(getAgentNote.pending, (state, action) => {})
      .addCase(getAgentNote.fulfilled, (state, action) => {
        state.agentNote = action.payload.data;
      })
      .addCase(getAgentNote.rejected, (state, action) => {});
  },
});

export const listAgentActions = listAgentSlice.actions;

export const selectListAgent = (state: any) => state.listAgent.agents;
export const selectAgentNote = (state: any) => state.listAgent.agentNote;
export const selectLoading = (state: any) => state.listAgent.loading;

const agentReducer = listAgentSlice.reducer;
export default agentReducer;
